import React, { createContext, useContext } from 'react';

const DocumentsViewContext = createContext({});

export const useDocumentsViewContext = () => useContext(DocumentsViewContext);

export const DocumentsContextProvider = ({ children, value }) => (
  <DocumentsViewContext.Provider value={value}>
    {children}
  </DocumentsViewContext.Provider>
);
